export const ssoRoutes = [

    { path: '/auth/callback', name: 'AuthCallback',  component: () => import('../views/AuthCallback.vue'), },
];
